import { render, staticRenderFns } from "./BikeMaintenancesHistory.vue?vue&type=template&id=405516b0&lang=pug&"
import script from "./BikeMaintenancesHistory.vue?vue&type=script&lang=js&"
export * from "./BikeMaintenancesHistory.vue?vue&type=script&lang=js&"
import style0 from "./BikeMaintenancesHistory.vue?vue&type=style&index=0&id=405516b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports